__turbopack_context__.v({
  "separator": "OrSeparator-module__a8VU5W__separator",
});
